import { render, staticRenderFns } from "./SendSmsModal.vue?vue&type=template&id=54933b32&"
import script from "./SendSmsModal.vue?vue&type=script&lang=js&"
export * from "./SendSmsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports